import { Box, Stack, Typography } from '@mui/material'
import { RadarChart } from '@mui/x-charts'

const LinkStatusChart = ({ data = [] }) => {
  const chartData = data.slice(0, 6).reduce(
    (acc, prev) => {
      return {
        count: [...acc.count, {
          gateway: prev.gateway,
          count: prev.count
        }],
        snr: [...acc.snr, {
          gateway: prev.gateway,
          snr: prev.snr
        }],
        rssi: [...acc.rssi, {
          gateway: prev.gateway,
          rssi: prev.rssi
        }]
      }
    },
    {
      count: [],
      snr: [],
      rssi: []
    }
  )

  // add offset to snr and rssi graph values (negative values managed correctly with radar)
  const snrData = chartData.snr.map(item => item.snr)
  const snrMin = snrData.length > 0 ? Math.min(...snrData) : 0
  const snrOffset = snrMin < 0 ? -snrMin + 5 : 0
  const snrDisplayData = snrData.map(v => v + snrOffset)

  const rssiData = chartData.rssi.map(item => item.rssi)
  const rssiMin = rssiData.length > 0 ? Math.min(...rssiData) : 0
  const rssiOffset = rssiMin < 0 ? -rssiMin + 5 : 0
  const rssiDisplayData = rssiData.map(v => v + rssiOffset)

  return (
    <Stack
      spacing={5}
      alignItems={'center'}
    >
      <Box sx={{
        width: '80%',
        height: '350px'
      }}>
        <Typography
          variant="h5"
          align="center"
          pb={3}
        >
          Count
        </Typography>
        <RadarChart
          height={300}
          shape='circular'
          highlight={chartData.count.length === 1 ? 'none' : 'axis'}
          series={[{ data: chartData.count.map(item => item.count) }]}
          radar={{
            max: Math.max(...chartData.count.map(item => item.count)) + 5,
            metrics: chartData.count.length === 1 ? [`${chartData.count[0].gateway} (${chartData.count[0].count})`] : chartData.count.map(item => item.gateway)
          }}
        />
      </Box>

      <Box sx={{
        width: '80%',
        height: '350px'
      }}>
        <Typography
          variant="h5"
          align="center"
          pb={3}
        >
          SNR
        </Typography>
        <RadarChart
          height={300}
          shape='circular'
          highlight={chartData.snr.length === 1 ? 'none' : 'axis'}
          series={[{
            data: snrDisplayData,
            valueFormatter: value => `${(value - snrOffset).toFixed(2)}`
          }]}
          radar={{
            max: Math.max(...snrDisplayData) + 5,
            metrics: chartData.snr.length === 1 ? [`${chartData.snr[0].gateway} (${chartData.snr[0].snr})`] : chartData.snr.map(item => item.gateway)
          }}
        />
      </Box>

      <Box sx={{
        width: '80%',
        height: '350px'
      }}>
        <Typography
          variant="h5"
          align="center"
          pb={3}
        >
          RSSI
        </Typography>
        <RadarChart
          height={300}
          shape='circular'
          highlight={chartData.rssi.length === 1 ? 'none' : 'axis'}
          series={[{
            data: rssiDisplayData,
            valueFormatter: value => `${(value - rssiOffset).toFixed(2)}`
          }]}
          radar={{
            max: Math.max(...rssiDisplayData) + 5,
            metrics: chartData.rssi.length === 1 ? [`${chartData.rssi[0].gateway} (${chartData.rssi[0].rssi})`] : chartData.rssi.map(item => item.gateway)
          }}
        />
      </Box>
    </Stack>
  )
}

export default LinkStatusChart
